import React, { useRef, useState, useEffect } from "react";
import { Tooltip, useTheme, useMediaQuery } from "@mui/material";

const ToolTipTktCont = ({ children, title, placement = "top" }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // xs = mobile

  const textRef = useRef(null);
  const [overflowed, setOverflowed] = useState(false);

  // ---------------------------------------------------------
  //  Detect overflow – only on non-mobile screens
  // ---------------------------------------------------------
  useEffect(() => {
    if (isMobile) {
      setOverflowed(false);
      return;
    }

    const el = textRef.current;
    if (!el) return;

    const check = () => setOverflowed(el.scrollWidth > el.clientWidth);
    check();

    const ro = new ResizeObserver(check);
    ro.observe(el);
    return () => ro.disconnect();
  }, [children, isMobile]);

  // ---------------------------------------------------------
  //  Mobile → plain text (wrap allowed)
  // ---------------------------------------------------------
  if (isMobile) {
    return (
      <span style={{ wordBreak: "break-word" }}>
        {children ?? "N/A"}
      </span>
    );
  }

  // ---------------------------------------------------------
  //  Desktop / Tablet → ellipsis + tooltip when overflowed
  // ---------------------------------------------------------
  const tooltipTitle = title ?? children ?? "N/A";

  return (
    <Tooltip
      title={tooltipTitle}
      placement={placement}
      arrow
      disableHoverListener={!overflowed}
      PopperProps={{ sx: { zIndex: 1300 } }}
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: "background.paper",
            color: "text.primary",
            fontSize: "0.875rem",
            maxWidth: "300px",
            wordBreak: "break-word",
            padding: "8px",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          },
        },
      }}
    >
      <span
        ref={textRef}
        style={{
          display: "inline-block",
          maxWidth: "100%",
          overflow: "hidden",
          whiteSpace: "nowrap",
          textOverflow: "ellipsis",
          verticalAlign: "middle",
        }}
      >
        {children ?? "N/A"}
      </span>
    </Tooltip>
  );
};

export default ToolTipTktCont;